import { AuctionType } from '../../../../auctions/types';
import { useHookForm, createFieldHelper, FlexFormFields } from '@cksoftware/react-base';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import { SaleTypeFilterValue, filterToAuctionTypeMap, saleTypeFilterOptions } from './types/SaleTypeFilterGroups.ts';

type SaleTypeFilterModel = {
  saleType?: SaleTypeFilterValue;
};

type SaleTypeFilterProps = {
  onFilterChange: (types?: AuctionType[]) => void;
};

export const SaleTypeFilter = (props: SaleTypeFilterProps) => {
  const { formMethods } = useHookForm<SaleTypeFilterModel>();
  const helper = createFieldHelper<SaleTypeFilterModel>(formMethods);

  const filterField = helper
    .selectInput('saleType', { items: saleTypeFilterOptions })
    .withLabel('Search Sale Type')
    .withPlaceholder('Filter by Sale Type');

  // Watch for changes and call parent callback
  const watchedType = useWatch({
    name: 'saleType',
    control: formMethods.control
  });

  useEffect(() => {
    const auctionTypes = watchedType ? filterToAuctionTypeMap[watchedType] : undefined;
    props.onFilterChange(auctionTypes);
  }, [watchedType, props]);

  return (
    <Box width={'200px'}>
      <FlexFormFields formFields={[filterField]} />
    </Box>
  );
};
